// extracted by mini-css-extract-plugin
module.exports = {"content":"MessagesList_content__2q4nF","loading":"MessagesList_loading__1IQ4e","error":"MessagesList_error__ZNOVP"};